import { useQuery as t, useQueryClient as s, useMutation as y } from "@tanstack/react-query";
import { a as A, b as m } from "./use-account.DkVfV1FC.js";
import { S as c, q as r } from "./stale.constant.De1PuSBj.js";
const q = ({
  options: e
}) => t({
  queryKey: r.allStates(!!(e != null && e.isAbbreviationAsLabel)),
  queryFn: A,
  staleTime: c,
  select: (l) => l.data.map(({ abbreviation: a, name: u }) => ({
    value: a,
    label: e != null && e.isAbbreviationAsLabel ? a : u
  }))
}), L = (e) => {
  const l = s();
  return y({
    ...e,
    mutationFn: m,
    onSettled: (...a) => {
      var u;
      (u = e == null ? void 0 : e.onSettled) == null || u.call(e, ...a), l.invalidateQueries({
        queryKey: r.userAll
      });
    }
  });
};
export {
  L as a,
  q as u
};
